/** Shared web/native policy. Only successful, geocoded first-page city searches qualify. */
export const NEARBY_RECOVERY_MIN_RESULTS = 6;
export function getNearbyRecoveryRadiusSteps(radius?: number | null): number[] {
  const current = Number.isFinite(radius) && (radius ?? 0) > 0 ? radius! : 0;
  return [25, 50, 100].filter(step => step > current);
}
export function canRecoverNearbySearch(input: {
  hasTypedLocation: boolean; hasValidGeocode: boolean; hasMapBounds: boolean;
  isCountrySearch: boolean; page?: number;
}): boolean {
  return input.hasTypedLocation && input.hasValidGeocode && !input.hasMapBounds &&
    !input.isCountrySearch && (input.page ?? 1) === 1;
}
